(function () {
'use strict';

angular
    .module('directives.systemsOwnershipGroups', ['services.systemOwnerReview', 'services.employees'])
    .directive('systemsOwnershipGroups', directive);

directive.$inject = ['$state', '$modal', 'systemOwnerReviewService', 'employeeService'];

function directive($state, $modal, systemOwnerReviewService, employeeService) {
    return {
        scope: {
            authLogin: '=',
            systemsOwned: '=',
            readOnly: '=',

            // Optional
            service: '@'
        },
        restrict: 'AE',
        templateUrl: require('./systemsOwnershipGroups.tpl.html'),
        link: link
    };

    function link(scope, element, attrs) {
        var service = employeeService;

        if (scope.service === 'review') {
            service = systemOwnerReviewService;
        }

        scope.groups =  _.groupBy(scope.systemsOwned, function (system) {
            return _.chain(system.SystemOwners)
                    .map('EmployeeID')
                    .sortBy()
                    .value();
        });

        scope.withSystems = Object.keys(scope.groups).length > 0;

        // Mode Multi Assignement
        scope.mode = {};
        scope.mode.multiAssignment = false;
        scope.mode.toConfirmMultiAssignment = false;
        scope.systemsForNewSystemGroup = [];

        scope.toggleModeMultiAssignment = function () {
            scope.mode.multiAssignment = !scope.mode.multiAssignment;

            if (!scope.mode.multiAssignment) {
                _.forEach(scope.systemsOwned, function (system) {
                    system.newSystemGroup = false;
                });
                scope.systemsForNewSystemGroup = [];
            }
        }

        scope.withDisplayedSystemsGroup = function (systemsGroup) {
            return _.findIndex(systemsGroup, function (systemGroup) { return systemGroup.newSystemGroup !== true }) !== -1;
        }

        // Add a new backup system owner
        scope.addBackup = function (system) {

            // Modal to select backup
            var modalScope = scope.$new(true);
			modalScope.system = system;
			modalScope.actualSystemOwners = system.SystemOwners;

            var chooserNewBackupModal = $modal({
                scope: modalScope,
                template: require('../controllers/systemOwner/SelectNewBackupSystemOwnerModal.tpl.html'),
                placement: 'center'
            });

            modalScope.hideModal = function () {
                chooserNewBackupModal.$promise.then(chooserNewBackupModal.hide);
            }

            modalScope.okModal = function () {
                modalScope.hideModal();
            }

            // Add the selected backup employee
            modalScope.newBackupEmployee = function (selectedEmployee) {
				service.addNewBackupSystemOwner(scope.authLogin, selectedEmployee.EmployeeID, [system])
                    .then(function (newBackupEmployeeObject) {

						modalScope.hideModal();
						$state.go($state.current, {}, { reload: true });
                    });
            }
        }

        // Remove backup System Owner
        scope.removeBackup = function (systemOwner, system) {
            var systems = [];
            systems.push(system);

            return service
                    .removeBackupSystemOwner(scope.authLogin, systemOwner.EmployeeID, systems)
                    .then(function () {
                        system.SystemOwners = _.filter(system.SystemOwners, function (so) {
                            return so.EmployeeID !== systemOwner.EmployeeID;
                        });
                    });
        }

        // Change primary System Owner
        scope.changePrimary = function (systemOwner, system) {

            // Modal to select primary
            var modalScope = scope.$new(true);
			modalScope.system = system;
			modalScope.actualSystemOwners = system.SystemOwners;

            var chooserNewPrimaryModal = $modal({
                scope: modalScope,
                template: require('../controllers/systemOwner/selectNewPrimarySystemOwnerModal.tpl.html'),
                placement: 'center'
            });

            modalScope.hideModal = function () {
                chooserNewPrimaryModal.$promise.then(chooserNewPrimaryModal.hide);
            }

            modalScope.okModal = function () {
                modalScope.hideModal();
            }

            // Change the selected primary employee
            modalScope.newPrimaryEmployee = function (selectedEmployee) {
                service
					.changePrimarySystemOwner(scope.authLogin, selectedEmployee.EmployeeID, [system])
                    .then(function (newPrimaryEmployee) {

                        modalScope.hideModal();

                        $state.go($state.current, {}, { reload: true });
                    });
            }
        }

        // Manage multi assignement mode
        scope.$watch('mode.multiAssignment', function (newValue, oldValue) {
            if (newValue === false) {
                scope.newSystemOwners = [];
                scope.canChangeBackups = true;
            }
        });

        scope.confirmModeMultiAssignement = function () {
            // No changes
            if (scope.systemsForNewSystemGroup.length === 0) return;

            // Change primary system owner
            var oldPrimarySystemOwner = scope.systemsForNewSystemGroup[0].SystemOwners[0];
            if (scope.primarySystemOwner.EmployeeID != oldPrimarySystemOwner.EmployeeID) {

                service
                    .changePrimarySystemOwner(scope.authLogin, scope.primarySystemOwner.EmployeeID, scope.systemsForNewSystemGroup)
                    .then(function (newPrimaryEmployee) {
                        $state.go($state.current, {}, { reload: true });
                    });

                return;
            }

            // Replace backups
            service
                .replaceBackupSystemOwners(scope.authLogin, scope.newSystemOwners, scope.systemsForNewSystemGroup)
                .then(function (newPrimaryEmployee) {
                    $state.go($state.current, {}, { reload: true });
                });
        };

        // When add system in system group
        scope.addSystemInSystemGroup = function (systemToAdd) {
            scope.systemsForNewSystemGroup.push(systemToAdd);
            updatePrimarySystemOwnerForNewGroup();
        }

        // When remove system from system group
        scope.removeSystemFromSystemGroup = function (systemToRemove) {
            scope.systemsForNewSystemGroup = _.filter(scope.systemsForNewSystemGroup, function (system) {
                return system.SystemID !== systemToRemove.SystemID;
            });
            updatePrimarySystemOwnerForNewGroup();
        }

        // Update Primary System Owner for new group
        function updatePrimarySystemOwnerForNewGroup() {
            var newNbSystems = scope.systemsForNewSystemGroup.length;

            if (newNbSystems === 0) {
                scope.primarySystemOwner = undefined;
                return;
            }

            if (_.isUndefined(scope.primarySystemOwner) && newNbSystems > 0) {
                scope.primarySystemOwner = scope.systemsForNewSystemGroup[0].SystemOwners[0];
            }
        }

        scope.newSystemOwners = [];
        scope.canChangeBackups = true;

        // Add a new backup to New System Owners
        scope.addBackupToNewSystemOwners = function () {

            // Modal to select backup
            var modalScope = scope.$new(true);
            modalScope.systemsGroup = scope.systemsForNewSystemGroup;
            modalScope.actualSystemOwners = [];

            var chooserNewBackupModal = $modal({
                scope: modalScope,
                template: require('../controllers/systemOwner/SelectNewBackupSystemOwnerModal.tpl.html'),
                placement: 'center'
            });

            modalScope.hideModal = function () {
                chooserNewBackupModal.$promise.then(chooserNewBackupModal.hide);
            }

            modalScope.okModal = function () {
                modalScope.hideModal();
            }

            // Add the selected backup employee
            modalScope.newBackupEmployee = function (selectedEmployee) {
                scope.newSystemOwners.push(selectedEmployee);

                modalScope.hideModal();
            }
        };

        // Remove backup from New System Owners
        scope.removeBackupFromNewSystemOwners = function (systemOwner) {
            scope.newSystemOwners = _.filter(scope.newSystemOwners, function (systemOwner) {
                return systemOwner.EmployeeID !== systemOwner.EmployeeID;
            });
        };

        // Change New Systems Primary System Owner
        scope.changeNewSystemsGroupPrimary = function (systemOwner) {
            // Modal to select primary
            var modalScope = scope.$new(true);
            modalScope.actualSystemOwners = scope.newSystemOwners;

            var chooserNewPrimaryModal = $modal({
                scope: modalScope,
                template: require('../controllers/systemOwner/selectNewPrimarySystemOwnerModal.tpl.html'),
                placement: 'center'
            });

            modalScope.hideModal = function () {
                chooserNewPrimaryModal.$promise.then(chooserNewPrimaryModal.hide);
            }

            modalScope.okModal = function () {
                modalScope.hideModal();
            }

            // Change the selected primary employee
            modalScope.newPrimaryEmployee = function (selectedEmployee) {
                scope.primarySystemOwner = selectedEmployee;
                scope.primarySystemOwner.IsPrimary = true;

                var oldPrimarySystemOwner = scope.systemsForNewSystemGroup[0].SystemOwners[0];

                if (scope.primarySystemOwner.EmployeeID != oldPrimarySystemOwner.EmployeeID) {
                    scope.canChangeBackups = false;
                    scope.newSystemOwners = [];
                } else {
                    scope.canChangeBackups = true;
                }

                modalScope.hideModal();
            }
        };

        // Get systems in new group
        scope.getSystemsInNewGroup = function () {
            return _.filter(scope.systemsForNewSystemGroup, { 'newSystemGroup': true });
        };
    }
}
})();
